
const digest = '1019a08e26a645d419b527e797c14526cfc44c76ed05c267bd27e0435ed24f7f';
const classes = {"wrapper":"_wrapper_prkzn_1","listWrapper":"_list-wrapper_prkzn_11","expanded":"_expanded_prkzn_19"};
const css = `._wrapper_prkzn_1 {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 7px 0 2px;
  background: #edf7fc;
  border-radius: 5px;
  margin: 2px 0;
}

._list-wrapper_prkzn_11 {
  height: 0;
  overflow: hidden;
  transform: scaleY(0);
  transform-origin: top;
  opacity: 0;
}

._list-wrapper_prkzn_11._expanded_prkzn_19 {
  height: auto;
  transform: scaleY(1);
  opacity: 1;
  background: #fff;
  margin: 5px;
  padding: 5px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  